/* eslint-disable prettier/prettier */
import Cookies from 'js-cookie';
const $ = jQuery.noConflict();
const contentContainer = `trip-grid`;
const searchFor = 'h2';

const mobileNavClick = () => {
	const mobileNavHeaders = document.querySelectorAll(
		'.trip-grid__mobile-nav-header'
	);

	mobileNavHeaders.forEach( ( mobileNavHeader ) => {
		mobileNavHeader.addEventListener( 'click', function () {
			const navWrapper = this.closest( '.trip-grid__navigation-wrapper' );
			if ( navWrapper ) {
				navWrapper.classList.toggle( 'active' );
			}
		} );
	} );

	$( 'html' ).on( 'click', '.table-of-contents__title-link', function () {
		$( '.trip-grid__navigation-wrapper' ).removeClass( 'active' );
	} );
};

const addSidebarItems = () => {
	const els = Array.from(
		document.querySelectorAll( `.${ contentContainer } ${ searchFor }` )
	);
	linkHeadings( els );
};

const sidebarLinks = () => {
	if ( $( '.trip-grid__nav-contacts a[href*="contact-us"]' ).length ) {
		const tripTitle = $( '.hero-trip__trip-title' ).data( 'title' );
		$( '.trip-grid__nav-contacts a[href*="contact-us"]' ).each( function () {
			let CtaBlockHref = $( this ).attr( 'href' );
			CtaBlockHref +=
				( CtaBlockHref.indexOf( '?' ) !== -1 ? '&' : '?' ) +
				'trip=' +
				encodeURIComponent( tripTitle ).replace( /%20/g, '+' );
			$( this ).attr( 'href', CtaBlockHref );
		} );
	}
};

const sidebarSingleLink = () => {
	const $contactBlock = $('.trip-grid__nav-contacts');
	const newUrl = $contactBlock.data('url');
	if (newUrl) {
		$contactBlock.find('a[href*="contact-us"]').each(function () {
			$(this).attr('href', newUrl);
		});
	}
};

const tripFooterLinks = () => {
	if ( $( 'a[data-booking-link]' ).length ) {
		const bookOnlineLink = $( 'a[data-booking-link]' ).data( 'booking-link' );
		$(
			'.block-cta-standard .wp-block-button:not(".wp-block-button--icon-right"):first-child .wp-block-button__link'
		).attr( 'href', bookOnlineLink );
	} else if (
		$( 'a.download-itin-link' ).length &&
		$( 'a.download-itin-link' ).attr( 'href' ) !== ''
	) {
		const downloadItinLink = $( 'a.download-itin-link' ).attr( 'href' );
		$(
			'.block-cta-standard .wp-block-button:not(".wp-block-button--icon-right"):first-child .wp-block-button__link'
		)
			.attr( 'href', downloadItinLink )
			.text( 'Download Itinerary' )
			.addClass( 'download-itin-link' );
	} else {
		$(
			'.block-cta-standard .wp-block-button:not(".wp-block-button--icon-right"):first-child .wp-block-button__link'
		).addClass( 'block-inactive' );
	}
	if (
		$( '.hero-trip__overhang-links a[href*="contact-us"][href*="trip="]' )
			.length
	) {
		const OverhangLinksHref = $(
			'.hero-trip__overhang-links a[href*="contact-us"][href*="trip="]'
		).attr( 'href' );
		const urlParams = new URLSearchParams( OverhangLinksHref.split( '?' )[ 1 ] );
		const tripValue = urlParams.get( 'trip' );
		$( '.block-cta-standard a[href*="contact-us"]' ).each( function () {
			let CtaBlockHref = $( this ).attr( 'href' );
			CtaBlockHref +=
				( CtaBlockHref.indexOf( '?' ) !== -1 ? '&' : '?' ) +
				'trip=' +
				encodeURIComponent( tripValue ).replace( /%20/g, '+' );
			$( this ).attr( 'href', CtaBlockHref );
		} );
	} else {
		const tripTitle = $( '.hero-trip__trip-title' ).data( 'title' );
		$( '.block-cta-standard a[href*="contact-us"]' ).each( function () {
			let CtaBlockHref = $( this ).attr( 'href' );
			CtaBlockHref +=
				( CtaBlockHref.indexOf( '?' ) !== -1 ? '&' : '?' ) +
				'trip=' +
				encodeURIComponent( tripTitle ).replace( /%20/g, '+' );
			$( this ).attr( 'href', CtaBlockHref );
		} );
	}

	const $tripTitle = $('.hero-trip__trip-title');
	const contactUrl = $tripTitle.data('contact-url');
	if (contactUrl) {
		$('.block-cta-standard a[href*="contact-us"]').each(function () {
			$(this).attr('href', contactUrl);
		});
	}
};

const tripDownloadLinks = () => {
	const tripHero = $( '.trip-form-modal' );
	const tripItin = tripHero.attr( 'data-download-itin-pdf' );
	const tripId = tripHero.attr( 'data-trip-id' );
	const tripDownloadBtns = $( '.download-itin-link' );
	if ( tripHero.length ) {
		if ( $( 'form' ).length ) {
			$( '.gfield.trip-id input' ).val( tripId );
			$( '.gfield.trip-download-itin input' ).val( tripItin );
		}

		if ( tripItin !== '' ) {
			tripDownloadBtns.attr( 'href', tripItin );

			tripDownloadBtns.on( 'click', function ( e ) {
				const tripFormSubmitted = Cookies.get( 'trip_form_submitted' );

				if ( tripFormSubmitted !== undefined ) {
				} else {
					e.preventDefault();
					$(
						'.trip-form-modal .component-lightbox__container'
					).addClass( 'active' );

					$( '.trip-form-modal .trip-form-modal__modal' ).addClass(
						'active'
					);
				}
			} );
		} else {
			tripDownloadBtns.addClass( 'block-inactive' );
		}
	}
};

const tripLevelContent = () => {
	$( '.trip-level-content' ).on( 'click', function ( e ) {
		e.preventDefault();
		$( '.trip-form-modal .component-lightbox__container' ).addClass( 'active' );

		$( '.trip-form-modal .trip-form-modal__trip-level-content' ).addClass(
			'active'
		);
	} );
};

const tripImageDisplay = () => {
	$( '.trip-overview__expand-img' ).on( 'click', function ( e ) {
		e.preventDefault();
		$( '.trip-form-modal .component-lightbox__container' ).addClass( 'active' );

		$( '.trip-form-modal .trip-form-modal__trip-image' ).addClass( 'active' );
	} );
};

const checkSliderWidth = () => {
	document.querySelector( '.trip-grid__full-width' ).style.left = '0px';
	document
		.querySelector( ':root' )
		.style.setProperty( '--trip-from-left', '0' + 'px' );

	const fromLeft = document
		.querySelector( '.trip-grid__full-width' )
		.getBoundingClientRect().x;
	if ( fromLeft > 20 ) {
		document.querySelector(
			'.trip-grid__full-width'
		).style.left = `-${ fromLeft }px`;

		document
			.querySelector( ':root' )
			.style.setProperty( '--trip-from-left', fromLeft + 'px' );
	}
};

function linkHeadings ( lHeader ) {
	// Select all table-of-contents elements
	const tocElements = document.querySelectorAll( '.table-of-contents' );

	tocElements.forEach( ( toc ) => {
		// Clear existing data if any
		toc.innerHTML = '';

		lHeader.forEach( ( element, index ) => {
			let elementTitleID = element.closest( 'section' ).getAttribute( 'id' );
			const elementTitle = element.textContent;

			if ( elementTitleID === null ) {
				elementTitleID = elementTitle
					.replace( /\s*&\s*|\s+/g, '-' )
					.toLowerCase();
			}

			if ( elementTitleID === 'what-the-trip-is-like' ) {
				elementTitleID = 'what-trip-is-like';
			} else if ( elementTitleID === 'trip-leaders' ) {
				elementTitleID = 'leaders';
			} else if ( elementTitleID === 'extend-your-trip' ) {
				elementTitleID = 'extensions';
			}

			const elementId = elementTitleID;
			let headerClass = 'table-of-contents__title';

			// Add ID to scroll to
			element.closest( 'section' ).setAttribute( 'id', elementId );

			// Add active to first item
			if ( index === 0 ) {
				headerClass += ' active';
			}

			// Add to the current table of contents
			toc.innerHTML += `<li data-id="${ elementId }" class="${ headerClass }">
		<a href="#${ elementId }" class="table-of-contents__title-link has-t-5-font-size">${ elementTitle }</a>
	</li>`;
			element.classList.add( 'is-in-view' );
		} );
	} );

	// Add intersection observer
	const shownHeadings = document.querySelectorAll( '.is-in-view' );
	const sideBarItems = document.querySelectorAll( '.table-of-contents__title' );

	const headingObserver = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					activeSideItem(sideBarItems, entry.target.id);
				}
			});
		},
		{
			root: null, // viewport
			rootMargin: '0px 0px -60% 0px', // top element 40% to the viewport
			threshold: 0.1 // just the 10% visible of the element in the viewport
		}
	);


	shownHeadings.forEach( ( shownHeading ) => {
		headingObserver.observe( shownHeading.closest( 'section' ) );
	} );
}

function activeSideItem ( sideBarItems, theItemId ) {
	sideBarItems.forEach( ( el ) => {
		if ( el.dataset.id === theItemId ) {
			el.classList.add( 'active' );
			document
				.querySelectorAll( '.trip-grid__mobile-nav-header p' )
				.forEach( ( p ) => {
					p.innerHTML = el.textContent;
				} );
		} else {
			el.classList.remove( 'active' );
		}
	} );
}

function setBlockBackground () {
	const blocks = Array.from(
		document.querySelectorAll( '.trip-grid__content-area-element' )
	).filter( ( el ) => el.querySelector( 'div, section' ) );

	if ( blocks.length <= 1 ) return;

	for ( let i = blocks.length - 2; i >= 0; i -= 2 ) {
		const block = blocks[ i ];
		block.classList.add( 'trip-grid__content-area-element_bg' );
	}
}
function goToHash () {
	let hash = window.location.hash;
	if ( hash.startsWith( '#gallery-lightbox-' ) ) {
		const index = hash.replace( '#gallery-lightbox-', '' );
		const element = document.querySelector(
			`.component-lightbox [data-slick-index="${ index }"] .component-lightbox__open`
		);
		if ( element ) {
			element.click();
			hash = '#gallery';
		}
	}

	if ( hash === '#gallery-lightbox' ) {
		document
			.querySelector(
				`.component-lightbox [data-slick-index="0"] .component-lightbox__open`
			)
			.click();
		hash = '#gallery';
	}
	const tocLink = document.querySelector(
		`.table-of-contents__title a[href="${ hash }"]`
	);
	setTimeout( () => {
		if ( tocLink ) {
			tocLink.click();
		}
	}, 600 );
}

// GLOBAL APP CONTROLLER
const controller = {
	init () {
		mobileNavClick();
		tripDownloadLinks();
	},
	loaded () {
		//scrollTargetSection();
		addSidebarItems();
		checkSliderWidth();
		sidebarLinks();
		sidebarSingleLink();
		tripFooterLinks();
		tripDownloadLinks();
		tripLevelContent();
		tripImageDisplay();
		setBlockBackground();
		if ( window.location.hash ) {
			goToHash();
		}
	},
	resized () {
		checkSliderWidth();
	},
	scrolled () { },
	keyDown () { },
	mouseUp () { },
};
export default controller;
